import Pqp from "../../3x1010/Pqp.js";

export default class DialogShare {
  constructor(btn, dialog) {
    this.btn = btn;
    this.dialog = dialog;
    this.timing;
    this.handleEscapeKey;
  }

  init() {
    if (!this.btn || !this.dialog) return;

    // show dialog
    this.btn.addEventListener("click", this.showDialog.bind(this));        

    // on btnClose click
    const btnClose = this.dialog.querySelector(".js-dialog-close");
    if (!btnClose) return;

    btnClose.addEventListener("click", this.hideDialog.bind(this));

    // on clickout
    const overlay = this.dialog.querySelector(".overlay");
    overlay?.addEventListener("click", this.hideDialog.bind(this));

    // on btnCopy click
    const btnCopy = this.dialog.querySelector(".js-btn-copy");
    if (!btnCopy) return;

    if (!navigator?.clipboard?.writeText) return;
    btnCopy.addEventListener("click", this.onBtnCopyClick.bind(this));
  }

  onBtnCopyClick() {
    navigator.clipboard
      .writeText(`${location.href}`)
      .then(() => {
        const feedback = this.dialog.querySelector(".js-copy-feedback");
        if (!feedback) return;

        feedback.classList.remove("is-hidden");
        clearTimeout(this.timing);
        this.timing = setTimeout(() => {
          !feedback.classList.contains("is-hidden")
            && feedback.classList.add("is-hidden");
        }, 1000);
      })
      .catch((err) => console.log(err));
  }

  showDialog() {
    this.dialog.classList.remove("is-hidden");    

    // set escape function id
    this.handleEscapeKey = (e) => {
      e.key === "Escape"
        && this.hideDialog();
    }

    // close on escape keydown
    window.addEventListener("keydown", this.handleEscapeKey);

    document.querySelector(".app")?.setAttribute("inert", "");
  }

  hideDialog() {
    if (this.dialog.classList.contains("is-hidden")) return;

    this.dialog.classList.add("is-hidden");

    // remove escape ev from window
    window.removeEventListener("keydown", this.handleEscapeKey);

    document.querySelector(".app")?.removeAttribute("inert");
  }
}